import * as yup from 'yup'

const councilMeetingValidationSchema = yup.object().shape({
    meetingDate: yup
        .string()
        .required('La date de l\'acte est requise')
        .matches(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/, 'Format attendu JJ/MM/AAAA'),
});

export default councilMeetingValidationSchema;